import React from 'react';
import { SvgIcon } from '@mui/material';

const InProgressIcon = () => (
   <SvgIcon>
      <circle cx="12" cy="12" r="10" fill="none" stroke="#FF9800" strokeWidth="2" />
   </SvgIcon>
);
export default InProgressIcon;
